import React, { ReactNode } from "react";

export type AppEtape = {
  id?: string;
  nom: string | ReactNode;
  etat: "OK" | "KO" | "NA" | "NF"; // valide, erreur, non active, non finalise
  index?: number;
  selectionne?: boolean;
  data?: any;
  erreur?: any;
};

const AppEtapes = ({ liste }: { liste: AppEtape[] }) => {
  const etapesItems = liste.map((item, index) => (
    <AppEtapeComponent key={item.id ?? index} {...item} index={index} />
  ));
  return (
    <div className="cart-steps">
      <ol className="cart-steps__wrapper">
        {etapesItems}
      </ol>
    </div>
  )
};

export const AppEtapeComponent = ({ etat, nom, index, selectionne }: AppEtape) => {
  return etat === "OK" && !selectionne ? (
    <li className="cart-steps__item cart-steps__item--active">
      <span className="icons__round   ">
        <span className="far fa-check" aria-hidden="true"></span>
      </span>
      <span className="cart-steps__label">{nom}</span>
    </li>
  ) : etat === "KO" || selectionne ? (
    <li className="cart-steps__item cart-steps__item--active">
      <span className="cart-steps__number">
        <span>{index! + 1}</span>
      </span>
      <span className="cart-steps__label">{nom}</span>
    </li>
  ) : (
    <li className="cart-steps__item ">
      <span className="cart-steps__number">
        <span>{index! + 1}</span>
      </span>
      <span className="cart-steps__label">{nom}</span>
    </li>
  );
};

export default AppEtapes;
